var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.999,
    height: 37.999,
    viewBox: "0 0 37.999 37.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INTELLIGENCE",
    transform: "translate(-5012.581 -7204.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-1",
    d: "M5166.569,7348.759a9.864,9.864,0,1,0,9.866,9.862A9.874,9.874,0,0,0,5166.569,7348.759Zm2.386,6.448c-.046-.033-.094-.063-.141-.1l1.634-3.945a8.269,8.269,0,0,1,1.525,1.024Zm-1.488-.654-.168-.033v-4.271a8.271,8.271,0,0,1,1.8.356Zm-1.627-.033-.166.033-1.636-3.947a8.308,8.308,0,0,1,1.8-.356Zm-1.514.591c-.046.033-.1.063-.141.1l-3.019-3.018a8.335,8.335,0,0,1,1.525-1.024Zm-1.172,1.127c-.033.047-.062.093-.1.141l-3.944-1.634a8.351,8.351,0,0,1,1.022-1.524Zm-.654,1.487c-.01.058-.022.112-.032.169H5158.2a8.236,8.236,0,0,1,.358-1.8Zm-.032,1.628c.01.054.022.109.032.166l-3.945,1.636a8.2,8.2,0,0,1-.358-1.8Zm.592,1.513c.032.049.062.1.095.141l-3.018,3.021a8.325,8.325,0,0,1-1.022-1.525Zm1.126,1.174c.045.032.095.063.141.094l-1.634,3.948a8.7,8.7,0,0,1-1.525-1.024Zm1.488.651c.055.012.111.025.166.033V7367a8.487,8.487,0,0,1-1.8-.356Zm1.625.033c.057-.008.111-.021.168-.033l1.635,3.95a8.448,8.448,0,0,1-1.8.356Zm1.516-.591c.047-.031.095-.062.141-.094l3.019,3.018a8.625,8.625,0,0,1-1.525,1.024Zm1.172-1.127c.032-.044.065-.092.095-.141l3.947,1.636a8.538,8.538,0,0,1-1.024,1.525Zm.653-1.487c.011-.057.022-.112.031-.166h4.272a8.366,8.366,0,0,1-.355,1.8Zm.031-1.625c-.009-.057-.021-.111-.031-.169l3.948-1.635a8.407,8.407,0,0,1,.355,1.8Zm-.59-1.516-.095-.141,3.018-3.018a8.566,8.566,0,0,1,1.024,1.524Z",
    transform: "translate(-134.99 -134.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-1",
    d: "M5045.015,7210.2a19,19,0,1,0,5.565,13.434A18.865,18.865,0,0,0,5045.015,7210.2Zm-1.031,25.838a17.541,17.541,0,1,1,5.139-12.4A17.415,17.415,0,0,1,5043.983,7236.037Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligence);
export default __webpack_public_path__ + "static/media/intelligence.669cee20d59250bcda814bde2b76a7bd.svg";
export { ForwardRef as ReactComponent };